<div class="appContent" fxLayout="column">
  
  
    <!-- <app-map fxFlex> </app-map> -->
    <app-baladya-map fxFlex></app-baladya-map>

    
    <div style="display: none;">
      <div id="ctr">
        <!-- <app-sequential-search ></app-sequential-search> -->
        <app-sub-seq-search></app-sub-seq-search>
      </div>
      
    </div>
  </div>